import React, { useEffect, useContext, useState, useRef } from 'react';
import { AppContext } from './RoutesWithAuth';
import { Route, Routes as RouterRoutes } from 'react-router-dom'
import axios from './components/common/AxiosConfig';
import IdleTimer from 'react-idle-timer';
import { signOut as amplifySignOut } from 'aws-amplify/auth';

import { getAuthToken, returnable, loadingScreen } from './components/common/AuthHelper';

import NewHomeUI from './components/routes/newUI/Home';
import NewAdminUI from './components/routes/newUI/Admin';
import Reports from './components/routes/newUI/Reports';
import Sessiontimeout from './components/common/Sessiontimeout';
import { ThemeProvider as MuiThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { ThemeProvider } from '@mui/styles';
import newUITheme from './components/routes/newUI/theme';
import { v2UIRoutePath } from './components/common/commons';
import Tracking from './components/routes/newUI/tracking';
import Resources from './components/routes/newUI/Resources';
import Centra from './components/routes/newUI/Centra';
import RequestDetailView from './components/routes/newUI/requestdetails/DetailsView';

function Routes(props) {
    const { authState } = props;

    const context = useContext(AppContext);

    const authToken = context.authToken.get
    const isAdmin = context.isAdmin.get
    const validUserContext = context.validUser.get
    const [usersList, setUsersList] = useState(null)
    const [modelIsOpen, setModelIsOpen] = useState(false);
    const IdleTimerRef = useRef(null);
    const sessionTimeOutRef = useRef(null);
    const [seconds, setSeconds] = useState(60);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (seconds > 0 && modelIsOpen) {
            setTimeout(() => {
                setSeconds(seconds - 1);
            }, 1000);
        } else {
            setSeconds(60);
        }
  // eslint-disable-next-line react-hooks/exhaustive-deps
},[seconds, modelIsOpen])
    const onIdle = () => {
        setModelIsOpen(true);
        sessionTimeOutRef.current = setTimeout(signOut, (60 * 1000 * 1));
    }
    const stayActive = () => {
        setSeconds(60);
        IdleTimerRef.current.reset();
        setModelIsOpen(false);
        clearTimeout(sessionTimeOutRef.current);
    }

    const signOut = async () => {
        console.log('signOut: Starting sign out process...');
        try {
            await amplifySignOut({ global: true });
            console.log('signOut: amplifySignOut completed');
            
            // Clear storage AFTER signOut
            localStorage.clear();
            sessionStorage.clear();
            
            // Set persistent flag to prevent auto-login
            localStorage.setItem('logged-out', 'true');
            
            // Redirect to Azure AD logout to end IdP session
            const idpLogoutUrl = process.env.REACT_APP_IDP_LOGOUT_URL;
            const postLogoutRedirect = `${window.location.origin}/session-expired`;
            
            if (idpLogoutUrl) {
                window.location.replace(`${idpLogoutUrl}?post_logout_redirect_uri=${encodeURIComponent(postLogoutRedirect)}`);
            } else {
                window.location.replace('/session-expired');
            }
        } catch (err) {
            console.error('signOut: Error during sign out:', err);
            // Fallback: force local logout
            localStorage.clear();
            sessionStorage.clear();
            localStorage.setItem('logged-out', 'true');
            window.location.replace('/session-expired');
        }
    }
    const loadAppDetails = () => {
        axios.get('apps/all', {
            headers: {
                Authorization: authToken
            }
        }).then(res => {
            let appsData = res.data;
            appsData.sort((a, b) => {
                const x = a.display.toLowerCase();
                const y = b.display.toLowerCase();
                if (x < y) { return -1; }
                if (x > y) { return 1; }
                return 0;
            })
            context.apps.set(appsData)
        }).catch(err => {
            context.apps.set([])
            console.log('There was an error fetching App Details!', err)
        })
    }
    useEffect(() => {
        if (authToken !== null) {
            setLoading(true);
            loadAppDetails();
            axios.get('users', {
                headers: {
                    Authorization: authToken
                }
            }).then(res => {
                setUsersList(res.data)
                setLoading(false);
            }).catch(err => {
                setLoading(false);
                console.log('There was an error fetching users!', err)
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authToken, isAdmin])

    useEffect(() => {
        if (authToken === null) {
            setLoading(true);
            getAuthToken(context)
        }
  // eslint-disable-next-line react-hooks/exhaustive-deps
},[authToken])

    // // Evaluate user access and admin flag once users list is loaded
    // useEffect(() => {
    //     if (usersList !== null) {
    //         const loggedInUserId = context.userId.get;
    //         const userRecord = usersList.find(({ user_id }) => user_id === loggedInUserId);
    //         if (userRecord) {
    //             context.isAdmin.set(userRecord.role === 'Admin');
    //             setUserAccessStatus(userRecord.user_status === 'Y' ? 'allowed' : 'disabled');
    //         } else {
    //             setUserAccessStatus('absent');
    //         }
    //     }
    // }, [usersList, context]);

    if (loading) {
        return loadingScreen();
    }

    if (authState !== 'signedIn' && validUserContext !== "exists") {
        return null
    }

   const temp = returnable(context, usersList)
    if (temp != null) {
        return temp;
    }


    return (
        <div className="">
            {modelIsOpen && <Sessiontimeout stayActive={stayActive} modelIsOpen={modelIsOpen} seconds={seconds} />}
            <StyledEngineProvider injectFirst>
                <MuiThemeProvider theme={newUITheme}>
                    <ThemeProvider theme={newUITheme}>
                        <RouterRoutes>
                            <Route path={v2UIRoutePath} element={<NewHomeUI />} />
                            <Route path={v2UIRoutePath + "requestdetails/:dsarRequestId"} element={<RequestDetailView />} />
                            <Route path={v2UIRoutePath + "admin"} element={<NewAdminUI />} />
                            <Route path={v2UIRoutePath + "admin/:page"} element={<NewAdminUI />} />
                            <Route path={v2UIRoutePath + "admin/:page/:tab"} element={<NewAdminUI />} />
                            <Route path={v2UIRoutePath + "page/:page"} element={<NewHomeUI />} />
                            <Route path={v2UIRoutePath + "reports"} element={<Reports />} />
                            <Route path={v2UIRoutePath + "reports/:reportname"} element={<Reports />} />
                            <Route path={v2UIRoutePath + "reports/:reportname/:tab"} element={<Reports />} />
                            <Route path={v2UIRoutePath + "resources"} element={<Resources />} />
                            <Route path={v2UIRoutePath + "resources/:page"} element={<Resources />} />
                            <Route path={v2UIRoutePath + "tracking"} element={<Tracking />} />
                            <Route path={v2UIRoutePath + "tracking/:page"} element={<Tracking />} />
                            <Route path={v2UIRoutePath + "tracking/:page/:id"} element={<Tracking />} />
                            <Route path={v2UIRoutePath + "centra"} element={<Centra />} />
                            <Route path={v2UIRoutePath + "centra/:page"} element={<Centra />} />
                        </RouterRoutes>
                    </ThemeProvider>
                </MuiThemeProvider>
            </StyledEngineProvider>
            <IdleTimer
                ref={IdleTimerRef}
                timeout={60 * 1000 * 59}
                onIdle={onIdle}
            />
        </div>
    );

}

export default Routes;
